// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "mail." + chunkId + "." + {"2":"4eb75e63deb4b0c472cc","177":"b13c0349e9565e741e8a","184":"04fc4542735b5cc70b14","921":"9d2b59c238018bb21b61","932":"91961646fbde926525ce","953":"b74228ce963beef12f3c"}[chunkId] + ".js";
};